import React from 'react';

const SuspenseSheet = () => {
  return <div>SuspenseSheet</div>;
};

export default SuspenseSheet;
